import React from 'react';
import type { FieldError, FieldErrorsImpl, Merge } from 'react-hook-form';
import { twMerge } from 'tailwind-merge';

type ErrorLabelProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  errorMessage: string | FieldError | Merge<FieldError, FieldErrorsImpl<any>>;
};

export const ErrorLabel: React.FC<ErrorLabelProps> = ({ errorMessage, className, ...props }) => (
  <p
    className={twMerge('mt-1.5 flex items-center gap-x-2.5', className)}
    {...props}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
    >
      <path
        d="M7.90669 14.5556C4.01025 14.5556 0.851562 11.3968 0.851562 7.50044C0.851562 3.604 4.01025 0.445312 7.90669 0.445312C11.8031 0.445312 14.9618 3.604 14.9618 7.50044C14.9618 11.3968 11.8031 14.5556 7.90669 14.5556ZM7.20118 9.61698V11.028H8.61221V9.61698H7.20118ZM7.20118 3.97288V8.20596H8.61221V3.97288H7.20118Z"
        fill="#FF154D"
      />
    </svg>
    <span className="text-sm text-input-error">{errorMessage as string}</span>
  </p>
);